import React, { Fragment, useEffect, useState } from "react";
import "../../assets/css/sap-master/sap-master.css";
import SearchIcon from "@mui/icons-material/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { Button, DialogActions, Grid, InputAdornment } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Dialog, DialogContent, DialogTitle, TextField } from "@mui/material";
import TextFiealdInput from "../components/textFiald";
import {
  addGroupDataData,
  clearGroupDataData,
} from "../../redux/sap-master/group-master-active-data-reducer";
import {
  business_channel_is_first,
  list_business_channel,
} from "../../redux/prefered-master/business-channel-list";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import AutoComplete from "../components/autocomplete-input";

import { raise_api_call_list_general_setting } from "../../redux/general-setting/list-general-setting-reducer";
import {
  add_business_channel,
  add_business_channel_isSuccess,
} from "../../redux/prefered-master/add-business-channel";
import {
  edit_business_channel,
  edit_business_channel_isSuccess,
} from "../../redux/prefered-master/edit-business-channel";
import { list_branch_master } from "../../redux/prefered-master/list-branch-master";
import {
  add_state_master,
  add_state_master_api_complete,
  add_state_master_isSuccess,
} from "../../redux/prefered-master/add-state-master";
import {
  list_state_master,
  list_state_master_is_first,
} from "../../redux/prefered-master/list-state-master";
import {
  edit_state_master,
  edit_state_master_api_complete,
  edit_state_master_isSuccess,
} from "../../redux/prefered-master/edit-state-master";
import CompletePopup from "../components/response-pop-up";
import SearchImg from "../../assets/images/search.svg";
import DataNotFound from "../../assets/images/no_data_found.svg";
import { useCommonContext } from "../../Utils/commonContext";

const StateMaster = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [responsePopup, setResponsePopup] = useState<boolean>(false);
  const [responseEdit, setResponseEdit] = useState<boolean>(false);
  const generalSettingList = useSelector((state: any) => state.GeneralSetting);
  const editStateMasterApi = useSelector((state: any) => state.EditStateMaster);
  const addStateMaster = useSelector((state: any) => state.AddStateMaster);
  const [isEdit, setEdit] = useState<boolean>(false);
  const [editData, setEditData] = useState<{
    state_code: string;
    state_name: string;
    dimension: string;
    active: boolean;
    country: string;
  }>({
    state_code: "",
    state_name: "",
    dimension: "",
    country: "",
    active: true,
  });
  const [activePartner, setActivePartner] = React.useState<null | number>(0);
  const [search, setSearch] = useState<string>("");
  const activeDatas = useSelector((state: any) => state.GroupMasterActiveData);
  const activeData = activeDatas.data;
  const { setTitleContext, setShowBack, setOnBackClick, isMobile } =
    useCommonContext();

  const state_master_list_data = useSelector(
    (state: any) => state.StateMasterList
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEdit(false);
  };
  // useEffect
  useEffect(() => {
    dispatch(list_state_master(""));

    dispatch(raise_api_call_list_general_setting(""));
    if (addStateMaster.isSuccess) {
      dispatch(add_state_master_isSuccess(""));
      setOpen(false);
    }
    if (editStateMasterApi.isSuccess) {
      dispatch(edit_state_master_isSuccess(""));
      setOpen(false);
      setEdit(false);
    }
    if (addStateMaster.api_completed) {
      setResponsePopup(true);
      dispatch(add_state_master_api_complete(false));
    }
    if (editStateMasterApi.api_completed) {
      setResponseEdit(true);
      dispatch(edit_state_master_api_complete(false));
      setResponsePopup(true);
    }
  }, [addStateMaster, editStateMasterApi]);

  const validationSchema = Yup.object().shape({
    state_code: Yup.string().required(" Required"),
    state_name: Yup.string().required("Required"),
    dimension: Yup.string().required("Required"),
    country: Yup.string().required("Required"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      state_code: isEdit ? editData.state_code : "",
      state_name: isEdit ? editData.state_name : "",
      active: isEdit ? editData.active : true,
      dimension: isEdit ? editData.dimension : "",
      country: isEdit ? editData.country : "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      submit(values);
    },
  });
  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    resetForm,
    errors,
  } = formik;

  const submit = (a: any) => {
    if (!isEdit) {
      const data = {
        state_code: a.state_code,
        state_name: a.state_name,
        active: a.active,
        dimension: a.dimension,
        country: a.country,
      };

      dispatch(add_state_master(data));
    } else {
      const data = {
        id: activeData.id,
        state_code: a.state_code,
        state_name: a.state_name,
        active: a.active,
        dimension: a.dimension,
        country: a.country,
      };
      dispatch(edit_state_master(data));
    }
  };

  const handleBack = () => {
    dispatch(clearGroupDataData());
    setShowBack(false);
    setTitleContext("State Master");
  };

  useEffect(() => {
    setOnBackClick(() => handleBack);
    return () => {
      dispatch(clearGroupDataData());
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    if (activeData?.state_name) {
      setShowBack(true);
    }
  }, [activeData]);

  useEffect(() => {
    setTitleContext(activeData.state_name ?? "State Master");
  }, [activeData]);

  // mainTable data
  const mainTable = () => {
    let filterarr: any = [];
    if (state_master_list_data.data.length != 0) {
      state_master_list_data.data.result.forEach((a: any) => {
        const data = { ...a };
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const created_on = new Date(a.created_on);
        // delete data.EffecDate;
        const created_date =
          created_on.getDate() +
          "-" +
          monthNames[created_on.getMonth()] +
          "-" +
          created_on.getFullYear();
        data.created_on
          ? (data.created_on = created_date)
          : console.log("sdfdsf");
        // update on
        const updated_on = new Date(data.updated_On);
        // delete data.EffecDate;
        const update_date =
          updated_on.getDate() +
          "-" +
          monthNames[updated_on.getMonth()] +
          "-" +
          updated_on.getFullYear();
        data.updated_On
          ? (data.updated_On = update_date)
          : console.log("sdfdsf");
        filterarr.push(data);
      });
    }
    console.log(values);
    // filterarr.filter((e) => delete e.id);
    // filterarr.filter((e) => delete e.active);
    // filterarr.filter((e) => delete e.created_by);
    // filterarr.filter((e) => delete e.updated_by);

    return (
      <Fragment>
        <div className="content_container">
          <div
            className={`mini_side_container`}
            style={{
              display: isMobile && activeData.id ? "none" : "initial",
            }}
          >
            <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
              State Master
            </h5>

            <div className="side_search_container">
              <TextField
                autoComplete="off"
                autoCorrect="off"
                spellCheck={false}
                placeholder="Search"
                className="side_search"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={SearchImg} alt="search" width="20px" />
                    </InputAdornment>
                  ),
                  style: {
                    borderRadius: "0px",
                    height: "45px",
                  },
                }}
              />
              <Button
                className="side_filter"
                disableRipple
                onClick={() => {
                  dispatch(list_business_channel(""));
                }}
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: "22px",
                    color: "var(--white-color)",
                  }}
                  icon={["fas", "arrows-rotate"]}
                />
              </Button>

              <Button
                className="side_filter"
                disableRipple
                onClick={() => {
                  handleClickOpen();
                }}
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: "22px",
                    color: "var(--white-color)",
                  }}
                  icon={["fas", "add"]}
                />
              </Button>
            </div>

            <div className="side_content_container">
              {filterarr
                .filter((item: any) => {
                  return Object.values(item)
                    .join("")
                    .toLowerCase()
                    .includes(search.toLowerCase());
                })
                .map((e: any, key: number) => {
                  if (state_master_list_data.isFirst && key === 0) {
                    dispatch(list_state_master_is_first(""));
                  }
                  return (
                    <div
                      key={key + 1}
                      onClick={(a) => {
                        setActivePartner(key);
                        dispatch(addGroupDataData(e));
                      }}
                      className={`side_content_card`}
                    >
                      <div
                        className={`side_content_mini_card ${
                          e.id === activeData.id ? "active" : ""
                        }`}
                      >
                        <div className="f4 title">{e.state_name}</div>
                        <div className="side_content_footer">
                          <h4 className="f4 subtitle">{e.state_code}</h4>
                          {/* <h4>{e.status}</h4> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

          <div
            className={`mini_content_container`}
            style={{
              display: isMobile && !activeData.id ? "none" : "initial",
            }}
          >
            {Object.keys(activeData).length === 0 ? (
              <div className="not_found_container">
                <img src={DataNotFound} alt="" />
                Please Select Any One State
              </div>
            ) : (
              <Fragment>
                <div className="content_header justify-content-end">
                  <div className="btns">
                    {Object.keys(activeData).length != 0 &&
                    activeData.state_name ? (
                      <Button
                        className="common_btn_outline"
                        disableRipple
                        onClick={() => {
                          setEdit(true);
                          setEditData(activeData);
                          handleClickOpen();
                        }}
                      >
                        Edit
                        <FontAwesomeIcon
                          icon="edit"
                          title="Edit partner onboarding"
                        />
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="scroll_content_container scroll_content_container_2">
                  <div className="grid_container">
                    <div className="detail_item">
                      <label className="f4">State Name</label>
                      <p>{activeData.state_name}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">State Code</label>
                      <p>{activeData.state_code}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Dimension</label>
                      <p>{activeData.dimension}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Country</label>
                      <p>{activeData.country}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Active</label>
                      <p>{activeData.active ? "Active" : "InActive"}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Create On</label>
                      <p>{activeData.created_on}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Update On</label>
                      <p>{activeData.updated_On}</p>
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </Fragment>
    );
  };
  const country_option =
    generalSettingList.data.length != 0
      ? generalSettingList.data.status
        ? generalSettingList.data.result
            .filter((e: any) => {
              if (e.page === "country") {
                return e;
              }
            })
            .sort((a: any, b: any) => {
              return a.description > b.description ? 1 : -1;
            })
            .map((e: any) => {
              const data = { label: e.description, value: e.name };
              return data;
            })
        : [{ label: "No data", value: null }]
      : [{ label: "No data", value: null }];

  return (
    <Fragment>
      <div className="partner-details">
        {responsePopup ? (
          <CompletePopup
            data={responseEdit ? editStateMasterApi : addStateMaster}
            responsePopup={responsePopup}
            setCompletePopup={(e: any) => {
              setResponsePopup(false);
              setResponseEdit(false);
            }}
          />
        ) : (
          ""
        )}
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={
            generalSettingList.isLoading || state_master_list_data.isLoading
              ? true
              : false
          }
        >
          {/* <CircularProgress color="inherit" /> */}
          <img
            style={{
              height: "150px",
            }}
            src={require("../../assets/images/3.gif")}
          ></img>
        </Backdrop>
        {mainTable()}
      </div>
      <Dialog
        PaperProps={{
          style: { borderRadius: 0 },
        }}
        open={open}
        onClose={handleClose}
        maxWidth={"md"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="dialog_header common_border_bottom">
          <h4 id="alert-dialog-title" className="f4">
            {"Add State"}
          </h4>

          <CancelIcon
            onClick={() => {
              handleClose();
            }}
          />
        </div>
        <DialogContent>
          <Grid container rowSpacing={3} columnSpacing={3}>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="state_name"
                label="State Name"
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="state_code"
                label="State Code"
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="dimension"
                label="Dimension"
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <AutoComplete
                pageOption={country_option}
                name="country"
                label="Country"
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
                vari={(e: any) => {
                  setFieldValue("country", e ? e.value : "");
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <div className="field_item">
                <FormControlLabel
                  value={values.active}
                  control={<Checkbox checked={values.active} />}
                  label="Is Active"
                  onChange={handleChange}
                  name="active"
                  labelPlacement="end"
                  sx={{
                    fontWeight: "700",
                  }}
                />
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <div className="dialog_footer">
            <Button
              disableRipple
              className="common_btn_outline"
              onClick={() => {
                handleClose();
                setEdit(false);
              }}
            >
              Cancel
            </Button>
            <Button
              className="common_btn"
              disableRipple
              onClick={() => {
                handleSubmit();
              }}
            >
              {addStateMaster.isLoading || editStateMasterApi.isLoading
                ? "Please Wait"
                : "Save"}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default StateMaster;
